export function addLightboxToGallery() {
    var galleries = document.querySelectorAll('.wp-block-gallery.is-style-lightbox-gallery');

    galleries.forEach(function(gallery) {
        var images = gallery.querySelectorAll('img');
        var imageArray = Array.from(images);

        imageArray.forEach(function(image, index) {
            image.addEventListener('click', function(event) {
                event.preventDefault();

                var lightbox = document.createElement('div');
                lightbox.classList.add('farlo-ui-lightbox', 'farlo-ui-lightbox--active');

                var lightboxBackdrop = document.createElement('div');
                lightboxBackdrop.classList.add('farlo-ui-lightbox__backdrop');

                var lightboxContainer = document.createElement('div');
                lightboxContainer.classList.add('farlo-ui-lightbox__inner', 'farlo-ui-lightbox__gallery');

                var img = document.createElement('img');
                img.src = this.src;

                var closeButton = document.createElement('button');
                closeButton.classList.add('farlo-ui-lightbox__close');
                closeButton.innerHTML = '<span></span>';
 
                closeButton.addEventListener('click', function() {
                    document.body.removeChild(lightbox);
                });

                var prevButton = document.createElement('button');
                prevButton.classList.add('farlo-ui-lightbox__gallery--prev');
                prevButton.innerHTML = '<span><</span>';
                prevButton.addEventListener('click', function() {
                    showImage(index - 1);
                });

                var nextButton = document.createElement('button');
                nextButton.classList.add('farlo-ui-lightbox__gallery--next');
                nextButton.innerHTML = '<span>></span>';
                nextButton.addEventListener('click', function() {
                    showImage(index + 1);
                });

                lightboxBackdrop.addEventListener('click', function(e) {

                        document.body.removeChild(lightbox);
                    
                });

                function showImage(newIndex) {
                    if (newIndex < 0) {
                        newIndex = imageArray.length - 1;
                    } else if (newIndex >= imageArray.length) {
                        newIndex = 0;
                    }
                    index = newIndex; // Update the index
                    img.src = imageArray[newIndex].src;
                }

                lightboxContainer.appendChild(prevButton);
                lightboxContainer.appendChild(img);
                lightboxContainer.appendChild(nextButton);
                lightbox.appendChild(closeButton);
                lightbox.appendChild(lightboxBackdrop);
                lightbox.appendChild(lightboxContainer);
                document.body.appendChild(lightbox);
            });
        });
    });
}
